import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Chip, Grid, Typography, useMediaQuery } from '@frontierag/frontier-ui-library';
import { ORDER_STATUS } from 'appConstants';

import { styles } from './styles';
import type { IOrderStatus, IStatusOptions } from './types';

const OrderStatus = ({ transNamespace, status, containerStyle = {} }: IOrderStatus) => {
  const { t } = useTranslation(transNamespace);
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  const statusOptions: IStatusOptions = useMemo(
      () => ({
        [ORDER_STATUS.OPEN]: { label: t('subtitle.open'), color: 'info' },
        [ORDER_STATUS.DRAFT]: { label: t('subtitle.draft'), color: 'warning' },
        [ORDER_STATUS.ERROR]: { label: t('subtitle.error'), color: 'error' },
        default: { label: status, color: 'info' },
      }),
      [t, status],
    ),
    _status = statusOptions[status?.toLowerCase()] || statusOptions.default;

  const labelVariant = isMobile ? 'label2' : 'label1';
  const chipSize = isMobile ? 'small' : 'medium';
  return (
    <Grid container columnSpacing={2} rowSpacing={2} alignItems="center" {...containerStyle}>
      <Grid item xs sx={{ maxWidth: { xs: 69 } }}>
        <Typography pr={2} variant="subtitle4">
          {t('subtitle.status')}
        </Typography>
      </Grid>
      <Grid item>
        <Chip
          label={<Typography variant={labelVariant}>{_status.label}</Typography>}
          color={_status.color}
          size={chipSize}
          sx={styles.chip}
          data-testid="order-status"
        />
      </Grid>
    </Grid>
  );
};

export default OrderStatus;
